import { z } from "zod";

/**
 * One ISO week of a bookings screen, as `GGGG-WW` — the convention the partner timeline reads —
 * and which of its records to list: `open`, the ones still waiting on the caller, which is what
 * an absent `filter` means, or `all` of them, processed ones included.
 */
export const getBookingsWeekQuerySchema = z.object({
	week: z.string().regex(/^\d{4}-\d{2}$/),
	filter: z.enum(["open", "all"]).optional(),
});

export type GetBookingsWeekQuerySchema = z.infer<typeof getBookingsWeekQuerySchema>;

/** Which records a week page of a bookings screen lists. */
export type BookingsWeekFilter = NonNullable<GetBookingsWeekQuerySchema["filter"]>;
